import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { enum_api_uri } from "../utils/enum";

interface Request {
    s_bl_no: string;
    b_file: File[];
}

interface Response {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: Request) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof Request];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePostConsoleBlImages = (): UseMutationResult<Response, Error, Request, unknown> => {
    // const queryClient = useQueryClient();
    const accessToken = useConsoleAuthStore(state => state.accessToken);
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
    };

    return useMutation<Response, Error, Request>({
        mutationFn: async (data: Request) => {
            const url = enum_api_uri.post_console_bl_images;
            const formData = createFormData(data);
            const response = await axiosInstance.post(url, formData, { headers });
            return response.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
